// extracted by mini-css-extract-plugin
export var circle = "styles-module--circle--a02f8";
export var label = "styles-module--label--7b0ac";
export var picker = "styles-module--picker--5256e";
export var slider = "styles-module--slider--bab30";
export var text = "styles-module--text--ec237";
export var thumb = "styles-module--thumb--7b0d3";
export var track = "styles-module--track--57cef";
export var wrapper = "styles-module--wrapper--db8c2";